<div class="header" id="header_container">
  <p class="header-text" id="header_title_label">{{ header }}</p>
  <div class="right-group">
    <mat-form-field class="language-select" id="select_language_button">
      <mat-select (selectionChange)="changeLanguage()" [(ngModel)]="selectedLanguage" id="select_language_options">
        <mat-option *ngFor="let language of languages" [value]="language.name">
          <img [src]="language.icon" alt="language" class="flag">
          {{ language.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-content></ng-content>
  </div>
</div>
